// Copyright 2022 - 2023 Fewcha. All rights reserved.

export type EventReducer = {
  startTime: string;
  endTime: string;
  paused: boolean;

  isStarted: boolean;
  isEnded: boolean;
  checkWhitelist: boolean;
};

export const defaultDate = "275760-09-13:00:00.000Z";

export const defaulEventReducer: EventReducer = {
  startTime: "275760-09-13:00:00.000Z", // start mint
  endTime: "275760-09-13:00:00.000Z", // start public sale
  paused: false, // stop mint

  isStarted: false,
  isEnded: false,
  checkWhitelist: false,
};

export type EvenResponse = {
  startTime: string;
  endTime: string;
  paused: boolean;
};
